<template>
  <el-tabs v-if="appStore.showNavbar" v-model="appStore.activeSystem" class="my-tabs" @tab-click="tabClick">
    <el-tab-pane
      v-for="item in state.tabs.filter((item) => item.name !== '南昌城市洪涝机理模型')"
      :key="item.name"
      :name="item.name"
    >
      <template #label>
        <span>{{ item.name }}</span>
        <el-icon v-if="item.name === '系统管理'" class="close" @click.stop="close1(item.name)">
          <Close />
        </el-icon>
      </template>
    </el-tab-pane>
    <el-tab-pane v-for="item in appStore.dynamicSystemList.values()" :key="item.name" :name="item.name">
      <template #label>
        <span>{{ item.name }}</span>
        <el-icon class="close" @click.stop="close(item.name)">
          <Close />
        </el-icon>
      </template>
    </el-tab-pane>
  </el-tabs>
</template>

<script setup>
import useAppStore from '@shared/store/useAppStore'
import { Close } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import storage, { Dynamic_System, Permission_Routes } from '@/shared/utils/storage'
import { computed } from 'vue'

const auth = computed(
  () =>
    appStore.isAuth('sys-user') ||
    appStore.isAuth('sys-role') ||
    appStore.isAuth('sys-perm') ||
    appStore.isAuth('sys-area') ||
    appStore.isAuth('sys-work') ||
    appStore.isAuth('sys-application') ||
    appStore.isAuth('sys-app-version') ||
    appStore.isAuth('sys-message-config') ||
    appStore.isAuth('sys-audit-log')
)
const props = defineProps({
  navData: {
    type: Array,
    default: () => []
  }
})
const router = useRouter()
const appStore = useAppStore()
const state = reactive({
  tabs: storage.getItem(Permission_Routes)
    ? storage
        .getItem(Permission_Routes)
        .filter((item) =>
          item.name === '系统管理'
            ? auth.value &&
              item.showSystem &&
              (appStore.isRole(['admin']) ||
                appStore.isAuth('sys-role6') ||
                appStore.isAuth('sys-role1') ||
                appStore.isAuth('sys-role'))
            : true
        )
    : appStore.permissionRoutes.filter((item) =>
        item.name === '系统管理'
          ? auth.value &&
            item.showSystem &&
            (appStore.isRole(['admin']) ||
              appStore.isAuth('sys-role6') ||
              appStore.isAuth('sys-role1') ||
              appStore.isAuth('sys-role'))
          : true
      ),
  previousTab: appStore.activeSystem
})
watch(
  () => props.navData,
  () => {
    state.tabs = props.navData
  },
  {
    deep: true
  }
)

watch(
  () => appStore.activeSystem,
  (val, oldVal) => {
    state.previousTab = oldVal
  }
)

const tabClick = (tab) => {
  // 动态添加的系统链接直接跳转
  let dynamicSystem = appStore.dynamicSystemList.get(tab.paneName)
  if (dynamicSystem) {
    router.push(dynamicSystem.path)
    appStore.activeSystem = tab.paneName
    return
  }

  dynamicSystem = appStore.dynamicSystemList.get(state.previousTab)
  appStore.activeSystem = tab.paneName
  // 如果是隐藏菜单栏的或者从动态系统跳过来的，跳转第一个路由
  if (appStore.activeSystemItem?.hiddenSideBar || dynamicSystem) {
    router.push(appStore.activeSystemItem.routes[0].children[0].path)
  }
}

const close = (name) => {
  appStore.dynamicSystemList.delete(name)

  if (name === appStore.activeSystem) {
    tabClick({
      paneName: appStore.permissionRoutes[0].name
    })
  }
}
console.log(storage.getItem(Permission_Routes), 'storage.getItem(Permission_Routes)')

const close1 = (name) => {
  appStore.permissionRoutes.forEach((item) => {
    if (item.name === name) {
      item.showSystem = false
    }
  })
  storage.setItem(Permission_Routes, appStore.permissionRoutes)
  state.tabs = appStore.permissionRoutes.filter((item) =>
    item.name === '系统管理'
      ? auth.value &&
        item.showSystem &&
        (appStore.isRole(['admin']) ||
          appStore.isAuth('sys-role6') ||
          appStore.isAuth('sys-role1') ||
          appStore.isAuth('sys-role'))
      : true
  )
  console.log(state.tabs, 'state.tabs')
  if (name === appStore.activeSystem) {
    tabClick({
      paneName: appStore.permissionRoutes[0].name
    })
  }
}

const dynamicSystemList = storage.getItem(Dynamic_System)
if (dynamicSystemList) {
  appStore.dynamicSystemList = new Map(JSON.parse(dynamicSystemList))
}
</script>

<style lang="scss" scoped>
.my-tabs {
  width: 80%;
  --el-tabs-header-height: 30px;

  :deep() {
    .el-tabs__nav-wrap::after {
      background-color: transparent;
    }

    .el-tabs__header {
      margin: unset;
    }

    .el-tabs__nav-next,
    .el-tabs__nav-prev {
      line-height: 32px;
    }

    .el-tabs__item {
      &:hover {
        .close {
          width: 14px;
        }
      }
    }
  }
}

.close {
  width: 0;
  margin-left: 5px;
  transition: all 0.3s;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    transform: rotate(90deg);
    color: #c45656;
  }
}
</style>
